// extracted by mini-css-extract-plugin
export default {"panel":"BaseModal_panel__Z3Kcb","title":"BaseModal_title__dKKDC","content":"BaseModal_content__lvLOP"};